import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(theme => ({
  /**
   * Neutral white button sitting next to the search field. `align-self: stretch` keeps it exactly
   * as tall as that field instead of hard-coding the input height.
   */
  filterButton: {
    '&.MuiButton-root': {
      flexShrink: 0,
      alignSelf: 'stretch',
      minHeight: 36,
      padding: '0 12px',
      fontSize: 13,
      fontWeight: 500,
      lineHeight: '16px',
      color: palette.shades[800],
      backgroundColor: palette.shades[100],
      border: "1px solid ".concat(palette.shades[300]),
      boxShadow: 'none',
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: 8
      },
      '& .MuiSvgIcon-root': {
        width: 20,
        height: 20
      },
      '&:hover': {
        backgroundColor: palette.shades[200],
        borderColor: palette.shades[400],
        boxShadow: 'none'
      }
    },
    // The toolbar paints every button icon white for the contained buttons; this one stays grey.
    '&&& path': {
      fill: palette.shades[700]
    }
  },
  filterIconWrap: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  filterBadge: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: palette.primary.main
  },
  // The month picker pops out of the panel, so the paper must not clip it.
  panelPaper: {
    width: 300,
    padding: 24,
    overflow: 'visible'
  },
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16
  },
  panelTitle: {
    fontWeight: 600
  },
  clearAllButton: {
    minWidth: 0,
    padding: 0,
    fontWeight: 400,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline'
    }
  },
  field: {
    marginBottom: 16
  },
  fieldLabel: {
    marginBottom: 6,
    fontWeight: 600
  },
  select: {
    width: '100%',
    fontSize: '0.875rem',
    '& .MuiSelect-select': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  placeholder: {
    color: theme.palette.text.disabled
  },
  optionsPaper: {
    maxWidth: 420,
    maxHeight: 320
  },
  optionItem: {
    paddingTop: 2,
    paddingBottom: 2
  },
  optionLabel: {
    '& .MuiTypography-root': {
      fontSize: '0.875rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  // Aligns the shared DatePicker with the small selects above it.
  monthField: {
    '& .react-datepicker-wrapper, & .MuiFormControl-root': {
      width: '100%'
    },
    '& .MuiOutlinedInput-root': {
      height: 40,
      fontSize: '0.875rem'
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.875rem',
      color: theme.palette.text.disabled,
      transform: 'translate(14px, 11px) scale(1)'
    },
    '& .MuiInputLabel-shrink': {
      color: theme.palette.text.secondary,
      transform: 'translate(14px, -7px) scale(0.75)'
    }
  },
  panelFooter: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));
export default useStyles;